import { useDispatch, useSelector } from "react-redux";
import {
    getMiljogebyr as getMiljogebyrAction,
    putMiljogebyrerSettKlarTilIne as putMiljogebyrerSettKlarTilIneAction,
} from "../../../../actions/miljogebyrerActions";
import SendTilIne from "../../../Common/Detalj/SendTilIne";

export default function SendTilIneContainer() {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const dispatch = useDispatch();

  const getMiljogebyr = (id) => dispatch(getMiljogebyrAction(id));
  const putMiljogebyrerSettKlarTilIne = () =>
    dispatch(putMiljogebyrerSettKlarTilIneAction(miljogebyr.id))
      .then(() => getMiljogebyr(miljogebyr.id))
      .catch();

  if (!miljogebyr.isMakulert && miljogebyr.isFeiletKemner) {
    return (
      <SendTilIne
        miljogebyr={miljogebyr}
        putMiljogebyrerSettKlarTilIne={putMiljogebyrerSettKlarTilIne}
        getMiljogebyr={getMiljogebyr}
      />
    );
  }
  return <span />;
}
